import { API } from '@Providers';

export default async function (type: string) {
  const payload = { type };
  const endpoint = '/api/shelter/settings/get-waiver-templates';

  return API({ endpoint, method: 'post', payload });
}
